import GMBErrorState from './GMBErrorState';

interface LoadingGridProps {
  cards?: number;
  sections?: number;
}

export function GMBLoadingState({ cards = 4, sections = 3 }: LoadingGridProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.from({ length: cards }).map((_, i) => (
          <div key={i} className="rounded-xl border border-gray-200 dark:border-gray-700 p-5 animate-pulse">
            <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-24 mb-3"></div>
            <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-16 mb-2"></div>
            <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-20"></div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {Array.from({ length: sections }).map((_, i) => (
          <div key={i} className="rounded-xl border border-gray-200 dark:border-gray-700 p-5 animate-pulse">
            <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-32 mb-4"></div>
            <div className="space-y-2">
              <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
              <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

interface GBMContentWrapperProps {
  error?: any;
  errorTitle?: string;
  onRetry?: () => void;
  loading?: boolean;
  children: React.ReactNode;
}

export function GBMContentWrapper({ error, errorTitle, onRetry, loading, children }: GBMContentWrapperProps) {
  if (error) {
    return <GMBErrorState title={errorTitle} message={error.message} onRetry={onRetry} />;
  }
  if (loading) {
    return <GMBLoadingState />;
  }
  return <>{children}</>;
}